import { Logger, StringUtils } from "neo-common";
import { AppContext } from "../../../../Common/AppContext";
import { Platforms } from "neo-games";
import { Dialog } from "./Dialog";
import { BalanceManager } from "../../../Managers/BalanceManager";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";

/**
 * Create dialog filled from code.
 * @class Dialog
 */
export class CashierDialog {
    static opened: boolean = false;

    private static _element: HTMLElement;
    private static _cashierButton: HTMLElement;
    private static _refreshButton: HTMLElement;
    private static _closeButton: HTMLElement;
    private static _closeButtonIcon: HTMLElement;

    static openDialog(): void {
        if (DEBUG) {
            Logger.debugGroup("CashierDialog", `openDialog()`);
        }

        Platforms.Platforms.dialogOpened("cashier", true);

        CashierDialog.opened = true;

        CashierDialog._element = document.getElementById("cashierDialog");
        if (CashierDialog._element != null) {
            CashierDialog._cashierButton = document.getElementById("cashierButton");
            if (CashierDialog._cashierButton != null) {
                CashierDialog._cashierButton.onclick = CashierDialog.onCashier;
            }

            CashierDialog._refreshButton = document.getElementById("refreshButton");
            if (CashierDialog._refreshButton != null) {
                if (AppContext.gameConfiguration.CashierMessageShowRefreshBalanceButton) {
                    CashierDialog._refreshButton.onclick = CashierDialog.onRefreshBalance;
                } else {
                    CashierDialog._refreshButton.style.display = "none";
                }
            }

            CashierDialog._closeButton = document.getElementById("cashierCloseButton");
            if (CashierDialog._closeButton != null) {
                CashierDialog._closeButton.onclick = CashierDialog.onClose;
            }

            CashierDialog._closeButtonIcon = document.getElementById("cashierCloseButtonIcon");
            if (CashierDialog._closeButtonIcon != null) {
                CashierDialog._closeButtonIcon.onclick = CashierDialog.onClose;
            }

            if (CashierDialog._element.classList.contains(Dialog.DisabledClass)) {
                CashierDialog._element.classList.remove(Dialog.DisabledClass);
            }
        }
    }

    static onCashier(): void {
        if (DEBUG) {
            Logger.debugGroup("CashierDialog", `onCashier()`);
        }

        PlayList.play("SND_Click");

        if (!StringUtils.isNullOrEmpty(AppContext.gameConfiguration.CashierUrl)) {
            Platforms.Platforms.gotoCasier({
                reason: "InsufficientFunds",
                target: AppContext.gameConfiguration.CashierUrl,
            }); //todo Second available reason: 'InsufficientFunds'
            if (Platforms.Platforms.handleOpenCashierPage) {
                return;
            }
            window.open(AppContext.gameConfiguration.CashierUrl, "_self");
        } else {
            Platforms.Platforms.gotoCasier();
        }
    }

    static onRefreshBalance(): void {
        if (DEBUG) {
            Logger.debugGroup("CashierDialog", `onRefreshBalance()`);
        }

        PlayList.play("SND_Click");

        BalanceManager.refreshBalance();
    }

    static onClose(): void {
        if (DEBUG) {
            Logger.debugGroup("CashierDialog", `onClose()`);
        }

        PlayList.play("SND_Click");
        CashierDialog.opened = false;

        Platforms.Platforms.dialogOpened("cashier", false);

        if (!CashierDialog._element.classList.contains(Dialog.DisabledClass)) {
            CashierDialog._element.classList.add(Dialog.DisabledClass);
        }

        if (FreeRoundBonus.id != null || FreeRoundBonus.otherOfferes.length > 0) {
            FreeRoundBonus.enableUi();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Dialogs/CashierDialog.ts
 **/